<div class="fixed inset-0 flex items-center justify-center bg-gray-800 bg-opacity-50" style="z-index: 1050;" (click)="closeComponent()">
  <div class="bg-white p-6 rounded shadow-lg w-96 text-center" (click)="$event.stopPropagation()">
    <h2 class="text-xl font-bold mb-4">Cambiar Estado</h2>
    
    <!-- Información de selección masiva -->
    <div *ngIf="isSelectingAllFiltered" class="bg-blue-100 border-l-4 border-blue-500 text-blue-700 p-4 mb-4">
      <p class="font-bold">Selección Masiva</p>
      <p>Se actualizarán <span class="font-bold">{{allFilteredCount}}</span> repuestos que cumplen con los filtros actuales.</p>
    </div>
    
    <!-- Panel de selección de estado (visible solo cuando no se está procesando) -->
    <div *ngIf="!isProcessing">
      <label for="statusSelect" class="block text-sm font-medium mb-2">Selecciona el nuevo estado:</label>
      
      <!-- Casilla desplegable para seleccionar el estado -->
      <select id="statusSelect" class="select select-bordered w-full" [(ngModel)]="selectedStatus">
        <option value="" disabled selected>-- Seleccione un estado --</option>
        <option *ngFor="let state of sparePartDeliveryStatus" [value]="state">
          {{ state }}
        </option>
      </select>
      
      <!-- Lista scrolleable de repuestos seleccionados (solo se muestra para selección no masiva) -->
      <div *ngIf="!isSelectingAllFiltered && selectedItems.length > 0" class="mt-4 max-h-40 overflow-y-auto border rounded p-2">
        <h3 class="text-sm font-medium mb-2">Repuestos seleccionados ({{selectedItems.length}}):</h3>
        <ul>
          <li *ngFor="let item of selectedItems" class="text-sm text-gray-700 border-b py-1">
            {{ item.sparePartName }}
          </li>
        </ul>
      </div>
      
      <!-- Resumen de la operación -->
      <div class="mt-4 p-2 bg-gray-100 rounded">
        <p class="font-medium">Total a actualizar: <span class="font-bold">{{getTotalToUpdate()}}</span> repuestos</p>
      </div>
    </div>
    
    <!-- Panel de progreso (visible solo durante el procesamiento) -->
    <div *ngIf="isProcessing" class="mt-4">
      <h3 class="text-lg font-medium mb-3">Actualizando estado...</h3>
      
      <!-- Barra de progreso -->
      <div class="w-full bg-gray-200 rounded-full h-4 mb-4">
        <div class="bg-blue-600 h-4 rounded-full text-xs text-white flex items-center justify-center" 
             [style.width.%]="progressPercentage">
          {{progressPercentage}}%
        </div>
      </div>
      
      <!-- Mensaje de progreso -->
      <div class="text-sm text-gray-600 italic my-2 min-h-[20px]">
        {{progressMessage}}
      </div>
      
      <!-- Contador de tiempo -->
      <div class="mt-3 p-2 rounded text-sm" 
           [ngClass]="{'bg-red-100 text-red-800': timeLeft <= 15, 'bg-gray-100': timeLeft > 15}">
        <i class="fas fa-clock mr-1"></i> 
        Tiempo restante: <span class="font-bold">{{timeLeft}}</span> segundos
      </div>
      
      <!-- Alerta de tiempo crítico -->
      <div *ngIf="timeLeft <= 15" class="mt-2 text-xs text-red-600">
        <i class="fas fa-exclamation-triangle mr-1"></i>
        La operación se cancelará si toma demasiado tiempo.
      </div>
      
      <!-- Contador de elementos -->
      <div class="mt-3 p-2 bg-blue-50 text-blue-700 rounded text-sm">
        <i class="fas fa-list-ul mr-1"></i>
        Actualizando <span class="font-bold">{{getTotalToUpdate()}}</span> repuestos
      </div>
    </div>
    
    <!-- Botones de acción -->
    <div class="mt-4 flex justify-end">
      <button class="btn btn-secondary mr-2" (click)="closeComponent()" [disabled]="isProcessing">
        Cancelar
      </button>
      <button class="btn btn-primary" (click)="applyStatusChange()" [disabled]="!selectedStatus || isProcessing">
        <span *ngIf="isProcessing" class="loading-spinner-sm mr-2"></span>
        {{isProcessing ? 'Procesando...' : 'Cambiar Estado'}}
      </button>
    </div>
  </div>
</div>

<style>
  .loading-spinner-sm {
    display: inline-block;
    width: 1rem;
    height: 1rem;
    border: 2px solid #f3f3f3;
    border-top: 2px solid #3498db;
    border-radius: 50%;
    animation: spin 1s linear infinite;
  }
  
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
</style>